import React, { useState, useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../store/auth";
import Button from "../components/Button";
import Input from "../components/Input";
import { motion } from "framer-motion";
import { BsLock, BsMailbox, BsFillQuestionCircleFill  } from "react-icons/bs"  // 🔹 ikony

export default function Login() {
  const [email, setEmail] = useState("");
    const [resetPasswordEmail, setResetPasswordEmail] = useState("");

  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loadingUser, setLoadingUser] = useState(true);
  const [showForgot, setShowForgot] = useState(false);

  const { user, loginStart, loginSuccess, loginError, isLoggingOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggingOut) return;
    async function fetchUser() {
      try {
        const res = await fetch("https://hs2api.razamit.pl/me", {
          method: "GET",
          credentials: "include",
        });
        if (res.status === 401) {
          loginSuccess(null);
          return;
        }
        const data = await res.json();
        loginSuccess(data.user || data);
      } catch {
        loginSuccess(null);
      } finally {
        setLoadingUser(false);
      }
    }
    fetchUser();
  }, [loginSuccess]);

  if (loadingUser)
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-900 text-white">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <div className="w-14 h-14 border-4 border-blue-400 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p>Ładowanie danych użytkownika...</p>
        </motion.div>
      </div>
    );

  if (user) return <Navigate to="/" replace />;

const handleSubmit = async (e) => {
  e.preventDefault();
  loginStart();
  setSubmitting(true);
  setErrorMessage("");

  try {
    const res = await fetch("https://hs2api.razamit.pl/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ login: email, password }),
    });

    if (!res.ok) {
      if (res.status === 401) {
        setErrorMessage("❌ Nieprawidłowy login lub hasło.");
      } else {
        setErrorMessage(`⚠️ Błąd serwera (${res.status})`);
      }
      loginError("Błąd logowania");
      return; // ⛔ nie pobieramy /me jeśli logowanie się nie udało
    }

    // ✅ jeśli logowanie OK — pobierz użytkownika
    const userRes = await fetch("https://hs2api.razamit.pl/me", { credentials: "include" });
    if (!userRes.ok) throw new Error("Nie udało się pobrać danych użytkownika");
    const userData = await userRes.json();

    loginSuccess(userData.user || userData);
    navigate("/", { replace: true });
  } catch (err) {
    console.error("Błąd logowania:", err);
    setErrorMessage("⚠️ Wystąpił błąd podczas logowania. Spróbuj ponownie później.");
    loginError(err.message);
  } finally {
    setSubmitting(false);
  }
};
const handleResetPassword = async ({ email }) => {
  console.log("Stare:", resetPasswordEmail);
 

  try {
    const data = await fetch("https://hs2api.razamit.pl/reset-password", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ resetPasswordEmail }),
    });

    if (!data.ok) {
      const errorData = await data.json();
     // showToast(errorData.message, "error");
      return;
    }
   // showToast("Hasło zmienione pomyślnie", "success");
       

   // handleLogout();
    setShowForgot(false); // zamykamy modal
  } catch (err) {
    alert(err.message);
  }
};
  return (
    <div className="min-h-screen relative flex items-center justify-center overflow-hidden bg-slate-950 px-4 py-8">

  {/* Tło / dekoracyjne gradienty */}
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    <div className="absolute -top-40 -left-40 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl" />
    <div className="absolute top-1/3 -right-40 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl" />
    <div className="absolute -bottom-40 left-1/3 w-96 h-96 bg-indigo-600/10 rounded-full blur-3xl" />

    {/* delikatna siatka */}
    <div
      className="absolute inset-0 opacity-[0.035]"
      style={{
        backgroundImage: `
          linear-gradient(rgba(255,255,255,0.8) 1px, transparent 1px),
          linear-gradient(90deg, rgba(255,255,255,0.8) 1px, transparent 1px)
        `,
        backgroundSize: "40px 40px",
      }}
    />
  </div>

  {/* Główna zawartość */}
  <div className="relative z-10 w-full max-w-md">

    {/* Logo + nagłówek */}
    <motion.div
      initial={{ opacity: 0, y: -25 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="text-center mb-7"
    >
      <div className="inline-flex items-center justify-center mb-5">
        <div className="relative">
          <div className="absolute inset-0 bg-blue-500/20 blur-2xl rounded-full scale-125" />

          <img
            src="https://hs2api.razamit.pl/logo.png"
            alt="Logo"
            className="relative h-16 sm:h-20 w-auto object-contain drop-shadow-2xl"
          />
        </div>
      </div>

      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-white">
        Panel administracyjny
      </h1>

      <p className="mt-2 text-sm sm:text-base text-slate-400">
        Bezpieczne zarządzanie systemem
      </p>
    </motion.div>

    {/* Box logowania */}
    <motion.div
      initial={{ opacity: 0, y: 35, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.6, delay: 0.1 }}
      className="
        relative
        overflow-hidden
        rounded-3xl
        border border-white/10
        bg-white/[0.07]
        backdrop-blur-2xl
        shadow-[0_25px_80px_rgba(0,0,0,0.45)]
        p-6 sm:p-8
      "
    >

      {/* górny błysk */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-400/70 to-transparent" />

      {/* Error */}
      {errorMessage && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="
            mb-6
            flex items-start gap-3
            rounded-2xl
            border border-red-400/20
            bg-red-500/10
            px-4 py-3
            text-red-200
            shadow-lg
          "
        >
          <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-500/20">
            <span className="text-xs font-bold">!</span>
          </div>

          <p className="text-sm leading-5 font-medium">
            {errorMessage}
          </p>
        </motion.div>
      )}

      {/* Nagłówek formularza */}
      <div className="mb-7">
        <h2 className="text-xl font-semibold text-white">
          Zaloguj się
        </h2>

        <p className="mt-1 text-sm text-slate-400">
          Wprowadź dane, aby uzyskać dostęp do systemu.
        </p>
      </div>

      <form
        onSubmit={handleSubmit}
        autoComplete="on"
        className="space-y-5"
      >

        {/* Login */}
        <div>
          <Input
            label="Login"
            type="text"
            name="username"
            autoComplete="username"
            icon={
              <BsMailbox className="w-4 h-4 text-slate-400" />
            }
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
          />
        </div>

        {/* Hasło */}
        <div>
          <Input
            label="Hasło"
            type="password"
            name="password"
            autoComplete="current-password"
            icon={
              <BsLock className="w-4 h-4 text-slate-400" />
            }
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />
        </div>

        {/* Zapomniane hasło */}
        <div className="flex justify-end">
          <button
            type="button"
            onClick={() => setShowForgot(true)}
            className="
              text-sm
              font-medium
              text-slate-400
              transition-colors
              hover:text-blue-400
            "
          >
            Nie pamiętam hasła
          </button>
        </div>

        {/* Przycisk */}
        <Button
          size="medium"
          variant="contained"
          type="submit"
          disabled={submitting}
          className="
            !w-full
            !mt-2
            !rounded-xl
            !py-3
            !font-semibold
            !text-white
            !bg-gradient-to-r
            !from-blue-600
            !to-indigo-600
            hover:!from-blue-500
            hover:!to-indigo-500
            !shadow-lg
            !shadow-blue-600/20
            transition-all
            duration-300
            hover:!shadow-blue-500/30
            hover:-translate-y-[1px]
            active:translate-y-0
          "
        >
          {submitting ? (
            <span className="flex items-center justify-center gap-2">
              <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white" />
              Logowanie...
            </span>
          ) : (
            "Zaloguj się"
          )}
        </Button>

      </form>

      {/* Informacja bezpieczeństwa */}
      <div className="mt-7 pt-6 border-t border-white/10">
        <div className="flex items-center gap-3">
          <div className="
            flex h-9 w-9 shrink-0
            items-center justify-center
            rounded-xl
            bg-emerald-500/10
            border border-emerald-400/10
          ">
            <BsLock className="h-4 w-4 text-emerald-400" />
          </div>

          <div>
            <p className="text-xs font-medium text-slate-300">
              Bezpieczne logowanie
            </p>

            <p className="text-[11px] text-slate-500">
              Dostęp tylko dla uprawnionych użytkowników
            </p>
          </div>
        </div>
      </div>

    </motion.div>

    {/* Stopka */}
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5, duration: 0.6 }}
      className="mt-6 text-center"
    >
      <p className="text-xs text-slate-500">
        Wersja systemu <span className="text-slate-400">1.0.1</span>
      </p>

      <p className="mx-auto mt-2 max-w-md text-[11px] leading-5 text-slate-600">
        Dostęp do systemu mają wyłącznie osoby uprawnione.
        Nieuprawnione próby logowania są rejestrowane i mogą
        być podstawą do podjęcia działań prawnych.
      </p>
    </motion.div>

  </div>

  {/* Modal resetowania hasła */}
  {showForgot && (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 px-4 backdrop-blur-sm">

      <motion.div
        initial={{ opacity: 0, scale: 0.92, y: 15 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="
          relative
          w-full max-w-sm
          overflow-hidden
          rounded-3xl
          border border-white/10
          bg-slate-900
          shadow-[0_25px_80px_rgba(0,0,0,0.6)]
          p-6
        "
      >

        {/* dekoracja */}
        <div className="
          absolute -top-20 -right-20
          h-40 w-40
          rounded-full
          bg-blue-500/10
          blur-3xl
        " />

        <div className="relative">

          <div className="
            mb-5
            flex h-12 w-12
            items-center justify-center
            rounded-2xl
            bg-blue-500/10
            border border-blue-400/10
          ">
            <BsLock className="h-5 w-5 text-blue-400" />
          </div>

          <h2 className="text-xl font-semibold text-white">
            Reset hasła
          </h2>

          <p className="mt-2 text-sm leading-5 text-slate-400">
            Wpisz swój adres e-mail, aby otrzymać
            link umożliwiający ustawienie nowego hasła.
          </p>

          <div className="mt-5">
            <Input
              size="small"
              label="Adres e-mail"
              type="email"
              value={resetPasswordEmail}
              onChange={(e) => setResetPasswordEmail(e.target.value)}
              fullWidth
            />
          </div>

          <div className="mt-6 flex gap-3">

            <Button
              size="small"
              onClick={() => setShowForgot(false)}
              variant="outlined"
              className="
                !flex-1
                !rounded-xl
              "
            >
              Anuluj
            </Button>

            <Button
              size="small"
              onClick={() => {
                handleResetPassword({ resetPasswordEmail });
                setShowForgot(false);
              }}
              variant="contained"
              color="success"
              className="
                !flex-1
                !rounded-xl
                !bg-gradient-to-r
                !from-blue-600
                !to-indigo-600
              "
            >
              Wyślij
            </Button>

          </div>

        </div>

      </motion.div>
    </div>
  )}

</div>
  );
}
